<template>
    <div>
        <div  v-if="user.is_planner &&
                    !assigned.klaar_at &&
                    (( request.is_tolk_opdracht && request.is_verlopen_begintijd) ||
                    ( !request.is_tolk_opdracht && assigned.media.length > 0 ))
                ">                                
            <div class="text-right padding-r-12">
                <button 
                    class="c-btn c-btn--text-link"
                    @click="modal.complete = true"                                
                >Gereed melden</button>
            </div>
            <c-modal v-show="modal.complete" @close="modal.complete = false">
                <c-block-complete
                    :request="request"
                    :assignment="assigned"
                    @completed="modal.complete = false"
                ></c-block-complete>
            </c-modal>
        </div>
        <div  v-if="user.is_planner && assigned.klaar_at && !request.is_tolk_opdracht">                                
            <div class="text-right padding-r-12">
                <button 
                    class="c-btn c-btn--text-link"     
                    @click="modal.reject = true"      
                >Afkeuren</button>
            </div>
            <c-reject-modal 
                v-show="modal.reject" 
                @close="modal.reject = false"
                @submit="submit"></c-reject-modal>
        </div>
    </div>
</template>

<script>
import CModal from '@components/Modal';
import CRejectModal from '@app/modals/Reject';
import CBlockComplete from '@components/blocks/Complete';

export default {
    components: { CModal, CBlockComplete, CRejectModal },
    props: {
        request: {
            type: Object,
            required: true
        },
        assigned: {
            type: Object,
            required: true
        },
        user: {
            type: Object,
            requred: true
        }
    },
    data() {
        return {
            modal: {
                complete: false,
                reject: false
            }
        }
    },
    methods: {
        submit(remark) {
             this.$xhr.post('/api/request-detail/' + this.request.id + '/reject/' + this.assigned.id + '/', { remark }).then( () => {
                 this.modal.reject = false;
                 this.$store.dispatch('request/changeAssignment');
             });
        }
    }
}
</script>